import React from 'react'
import moment from 'moment-mini'
import { Link } from 'react-router-dom'
import { ForumPost } from '../../store/member/memberTypings'
import { useTranslation } from 'react-i18next'

import cls from './forumBlock.module.sass'
import s from '../profile/materials/materialPreview.module.sass'

type Props = {
    forumPosts: ForumPost[]
    userForumPostsTotal: number
    withHeader?: boolean
}

const ForumLinks = ({ forumPosts, withHeader = false, userForumPostsTotal }: Props) => {
    const [t] = useTranslation()
    return (
        <>
            {/*{withHeader && <h2 className={'primary'}>{t('Participations in the forum')}</h2>}*/}
            {withHeader && (
                <div className={s['materialsPreview__row']}>
                    <div className={s['materialsPreview__row']}>
                        <div className={s['materialsPreview__title']}>{t('Participations in the forum')}</div>
                        <div className={s['materialsPreview__counter']}>{userForumPostsTotal}</div>
                    </div>
                </div>
            )}
            <div className={cls['forumBlock']}>
                {forumPosts.map((item) => (
                    <p key={item.datestamp} className={cls['linkLine']}>
                        <span className={cls['date']}>{moment.unix(item.datestamp).format(t('time format'))}</span>
                        <Link to={item.post_url} target="_blank" dangerouslySetInnerHTML={{ __html: item.subject }} />
                    </p>
                ))}
            </div>
        </>
    )
}

export default ForumLinks
